export const GET_SIMPLE_SCHEDULE = 'GET_SIMPLE_SCHEDULE';
export const GET_SIMPLE_SCHEDULE_SUCCESS = 'GET_SIMPLE_SCHEDULE_SUCCESS';
export const GET_SIMPLE_SCHEDULE_ERROR = 'GET_SIMPLE_SCHEDULE_ERROR';

export const POST_SIMPLE_SHEET = 'POST_SIMPLE_SHEET';
export const POST_SIMPLE_SHEET_SUCCESS = 'POST_SIMPLE_SHEET_SUCCESS';
export const POST_SIMPLE_SHEET_ERROR = 'POST_SIMPLE_SHEET_ERROR';